import React, { Component } from "react";

export default class ArchiveViewControl extends Component {
    constructor(props) {
        super(props);

        this.state = {
            list: "organization-archive__list--active",
            map: "organization-archive__map--active"
        };
    }

    renderListButton() {
        var extraClass = "button--secondary";
        var ariaPressed = false;

        if (this.props.activeView == "list") {
            extraClass = "button--primary";
            ariaPressed = true;
        }

        return (
            <button
                className={`organization-archive__list button small social-map__view-switcher ${extraClass} rewrite-css-vars`}
                onClick={e => this.props.onChangeView("list")}
                aria-label="list"
                aria-pressed={ariaPressed}
            >
                Lijst
            </button>
        );
    }

    renderMapButton() {
        var extraClass = "button--secondary";
        var ariaPressed = false;

        if (this.props.activeView == "map") {
            extraClass = "button--primary";
            ariaPressed = true;
        }

        return (
            <button
                className={`organization-archive__list button small ${extraClass} rewrite-css-vars`}
                onClick={e => this.props.onChangeView("map")}
                aria-label="map"
                aria-pressed={ariaPressed}
            >
                Kaart
            </button>
        );
    }

    renderSort() {
        if (this.props.activeView === "map") {
            return null;
        }

        return (
            <div className="organization-archive__sort">
                <label className="organization-archive__label" htmlFor="sort">
                    {" "}
                    Sorteer op:
                </label>
                <select
                    className="organization-archive__select"
                    value={this.props.sort}
                    onChange={e => this.props.onChangeSort(e.target.value)}
                    name="sort"
                    id="sort"
                >
                    <option className="organization-archive__item" value="asc">
                        A - Z{" "}
                    </option>
                    <option className="organization-archive__item" value="desc">
                        Z - A{" "}
                    </option>
                </select>
                <p>{this.state.value}</p>
            </div>
        );
    }

    render() {
        return (
            <div className="organization-archive__control">
                {/* {this.renderSort()} */}
                <div
                    className="organization-archive__control__list buttons buttons--toggle"
                    role="group"
                    aria-label="lijst of kaartweergave"
                >
                    {this.renderListButton()}
                    {this.renderMapButton()}
                </div>
            </div>
        );
    }
}
